export enum AttenduMissionType{
    Reception_MaS = 0,
    Mise_au_stock = 6,
    Reception = 5
}